'use client'

import { batch } from '@preact/signals-react'
import { useSignals } from '@preact/signals-react/runtime'
import { useClientNav } from '@susu/headless-commerce/features/navigation/components/ClientNavProvider'
import { enableScroll } from '@susu/headless-commerce/utils/scrollUtils'
import classNames from 'classnames'
import { type ReactNode, useCallback } from 'react'
import styles from './NavCloseButton.module.scss'

export type ClientNavCloseButtonProps = {
  children: ReactNode
  className?: string
}

export const ClientNavCloseButton = ({
  children,
  className,
}: ClientNavCloseButtonProps) => {
  useSignals()

  const { closeNav, closeSubMenu } = useClientNav()

  const handleClick = useCallback(() => {
    batch(() => {
      closeNav()
      setTimeout(
        () => {
          closeSubMenu()
          enableScroll()
        },
        window.innerWidth < 768 ? 250 : 0,
      )
    })
  }, [closeNav, closeSubMenu])

  const closeButtonClass = classNames(
    styles['nav__close-btn'],
    'nav__close-btn',
    className,
  )

  return (
    <button
      className={closeButtonClass}
      onClick={handleClick}
      type="button"
      data-testid="nav-close-button"
    >
      {children}
    </button>
  )
}
